$(document).ready(function() {
    //Google Map
    if ($("#map_canvas").length) {  //check if map exists
        function initialize() {

            var myLatlng = new google.maps.LatLng(53.001496, -1.277625);
            var mapCenter = new google.maps.LatLng(53.001496, -1.277625);
            var mapCanvas = document.getElementById('map_canvas');
            var mapOptions = {
                center: mapCenter,
                zoom: 13,
                scrollwheel: true,
                draggable: true,
                disableDefaultUI: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }

            var map = new google.maps.Map(mapCanvas, mapOptions)

            map.set('styles', [{
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [{
                    hue: '#ffff00'
                }, {
                    saturation: 30
                }, {
                    lightness: 10
                }]
            },]);

            var contentString =
                '<div id="content">' +
                '<div id="siteNotice">' +
                '</div>' +
                '<h1 id="firstHeading" class="firstHeading">Betta Fit Auto Centre</h1>' +
                '<div id="bodyContent" class="bodyContent">' +
                '<p><strong>Nottingham\'s Premier Auto Diagnostics Centre</strong></p>' +
                '<p>Unit 2, Amber Centre</p>' +
                '<p>Arctic Way, Kimberley</p>' +
                '<p>Giltbrook</p>' +
                '<p>Nottingham</p>' +
                '<p>NG16 2HS</p>' +
                '<p><strong>0115 9389190</strong></p>' +
                '</div>' +
                '</div>';

            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                animation: google.maps.Animation.DROP,
                title: 'Betta Fit Auto Centre'
            });

            setTimeout(function () {
                infowindow.open(map, marker);
            }, 1000);

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }

        google.maps.event.addDomListener(window, 'load', initialize);
    }
});

